var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.599976,
    y: 0.861328,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F2F8F1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3981_24924",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 29,
    height: 29
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.59998,
    y: 8.86133,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3981_24924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6 33.3613C22.2694 33.3613 21.9923 33.2495 21.7687 33.0259C21.5451 32.8023 21.4333 32.5252 21.4333 32.1947V24.0572C20.1889 24.0572 18.993 23.819 17.8458 23.3426C16.6986 22.8662 15.6875 22.1905 14.8125 21.3155C13.9375 20.4405 13.2666 19.4294 12.8 18.2822C12.3333 17.1349 12.1 15.9391 12.1 14.6947V13.528C12.1 13.1974 12.2118 12.9204 12.4354 12.6967C12.659 12.4731 12.9361 12.3613 13.2666 12.3613H14.4333C15.6583 12.3613 16.8444 12.5995 17.9916 13.0759C19.1389 13.5523 20.15 14.228 21.025 15.103C21.6278 15.7058 22.1284 16.3669 22.5271 17.0863C22.9257 17.8058 23.2319 18.5738 23.4458 19.3905C23.543 19.2544 23.65 19.1231 23.7666 18.9967C23.8833 18.8704 24.0097 18.7391 24.1458 18.603C25.0208 17.728 26.0319 17.0523 27.1791 16.5759C28.3264 16.0995 29.5222 15.8613 30.7666 15.8613H31.9333C32.2639 15.8613 32.5409 15.9731 32.7646 16.1967C32.9882 16.4204 33.1 16.6974 33.1 17.028V18.1947C33.1 19.4391 32.8618 20.6349 32.3854 21.7822C31.909 22.9294 31.2333 23.9405 30.3583 24.8155C29.4833 25.6905 28.4771 26.3613 27.3396 26.828C26.2021 27.2947 25.0111 27.528 23.7666 27.528V32.1947C23.7666 32.5252 23.6548 32.8023 23.4312 33.0259C23.2076 33.2495 22.9305 33.3613 22.6 33.3613Z",
    fill: "#80B870"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.a6736724915d164b63f72371f319285b.svg";
export { ForwardRef as ReactComponent };